const SUPPORTED_LANGUAGES = ['zh-Hant', 'en', 'vi', 'th'];

function resolveLocale(rawLang) {
  if (typeof rawLang !== 'string') {
    return null;
  }

  const locale = rawLang.toLowerCase();

  const exactMatch = SUPPORTED_LANGUAGES.find(lang => lang.toLowerCase() === locale);
  if (exactMatch) {
    return exactMatch;
  }

  if (locale.startsWith('zh')) {
    return 'zh-Hant';
  }

  if (locale.startsWith('en')) {
    return 'en';
  }

  if (locale.startsWith('vi')) {
    return 'vi';
  }

  if (locale.startsWith('th')) {
    return 'th';
  }

  if (locale.includes('-tw') || locale.includes('-cn')) {
    return 'zh-Hant';
  }

  return 'en';
}

export default resolveLocale;
